module.exports = __webpack_public_path__ + "media/customizations/granbyranch/logo-3d40759a9d8d491a0988d65271282c14.png";